<template>
  <b-form-group
    v-if="isPremium"
    :label="$t('tasks.form.repeatType')"
    label-for="repeat_type"
  >
    <v-select
      id="repeat_type"
      v-model="dataItem.repeat_type"
      :options="repeatTypeOptions"
      label="text"
      :reduce="item => item.value"
      @input="resetValue"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { packageLimit } from '@/libs/packageLimits'
import vSelect from 'vue-select'

export default {
  name: 'TasksRepeatTypeCard',
  components: { BFormGroup, vSelect },
  computed: {
    repeatTypeOptions() {
      return [
        { value: null, text: this.$t('tasks.form.repeatTypes.none') },
        ...['daily', 'weekly', 'monthly', 'yearly'].map(value => ({ value, text: this.$t(`tasks.form.repeatTypes.${value}`) })),
      ]
    },
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isPremium() {
      return packageLimit('PROJECTS', 1)
    },
  },
  methods: {
    resetValue() {
      this.dataItem.repeat_interval = null
      // Haftalık sabit Pazartesi ('1'); diğer tiplere geçişte stale config'i temizle
      if (this.dataItem.repeat_type === 'weekly') {
        this.dataItem.repeat_config = '1'
      } else if (this.dataItem.repeat_type !== 'monthly') {
        this.dataItem.repeat_config = null
      }
    },
  },
}
</script>
